import Vue from "vue";
import VueGtag from "vue-gtag";
import router from "../router";

// gather analytics only production
if (process.env.NODE_ENV === "production") {
    Vue.use(VueGtag, { config: { id: "G-464VR6BRPN" } }, router);
}
